import React, { useState } from 'react'
import style from './menu.mod.scss'
import { Dropdown, Tag } from '@components'
import { graphql, Link } from 'gatsby'

const Menu = ({ items, modifiers = [] }) => {
  const [activeIndex, setActiveIndex] = useState(-1)

  const handleToggle = curIndex => {
    setActiveIndex(curIndex)
  }

  const handleMouseEnter = curIndex => {
    if (activeIndex !== curIndex) {
      handleToggle(curIndex, false)
    }
  }

  const handleMouseLeave = () => {
    setActiveIndex(-1)
  }

  const transitionSettings = {
    exit: {
      length: 0.2
    },
    entry: {
      delay: 0.05
    }
  }

  const isPartiallyActive = ({ isPartiallyCurrent }) => {
    return isPartiallyCurrent
      ? {
          className: [style.menu__link, style['menu__link--parent']].join(' ')
        }
      : null
  }

  const linkConfig = {
    partiallyActive: true,
    className: style.menu__link,
    activeClassName: style['menu__link--current'],
    ...transitionSettings
  }

  return (
    <nav className={[style.menu, ...modifiers].join(' ')}>
      <ul className={style.menu__list}>
        {items.map((item, index) => {
          const { title, path, treeChildren, newTag } = item
          const linkLabelClassNames = [style.menu__linkLabel]

          if (newTag) {
            linkLabelClassNames.push(style['menu__linkLabel--has-tag'])
          }

          const renderLinkLabel = () => (
            <span className={linkLabelClassNames.join(' ')}>
              <span>{title}</span>
              {newTag && <Tag className={style.menu__tag}>New</Tag>}
            </span>
          )

          return (
            <li
              key={`menu__list--${index}`}
              className={style.menu__item}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() => handleMouseLeave(index)}
            >
              {treeChildren.length > 0 ? (
                item.disableMenuClick ? (
                  <a
                    href="javascript:void(0)"
                    {...linkConfig}
                    onFocus={() => handleToggle(index)}
                    aria-haspopup="true"
                    aria-controls={`menu-${index}-box`}
                    aria-expanded={index === activeIndex}
                    id={`menu-${index}-button`}
                  >
                    {renderLinkLabel()}
                  </a>
                ) : (
                  <Link
                    {...linkConfig}
                    to={path}
                    getProps={isPartiallyActive}
                    onFocus={() => handleToggle(index)}
                    aria-haspopup="true"
                    aria-controls={`menu-${index}-box`}
                    aria-expanded={index === activeIndex}
                    id={`menu-${index}-button`}
                  >
                    {renderLinkLabel()}
                  </Link>
                )
              ) : item.disableMenuClick ? (
                <a href="#" {...linkConfig}>
                  {renderLinkLabel()}
                </a>
              ) : (
                <Link getProps={isPartiallyActive} {...linkConfig} to={path}>
                  {renderLinkLabel()}
                </Link>
              )}
              {treeChildren.length > 0 && (
                <Dropdown
                  index={index}
                  items={treeChildren}
                  isOpen={index === activeIndex}
                />
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Menu

export const query = graphql`
  fragment MenuHelpersAllPages on SitePage {
    path
    pageContext
  }
`
